// components/ChartPreview.tsx
import React from "react";
import ReactECharts from "echarts-for-react";

interface ChartPreviewProps {
  colors: string[];
  background: string;
  tableHeaderBackground: string;
}

const ChartPreview: React.FC<ChartPreviewProps> = ({ colors, background, tableHeaderBackground }) => {
  const barOption = {
    color: colors,
    backgroundColor: background,
    xAxis: {
      type: 'category',
      data: ['North', 'South', 'East', 'West'],
    },
    yAxis: {
      type: 'value',
    },
    series: [
      {
        data: [120, 200, 150, 80],
        type: 'bar',
      },
    ],
    grid: { left: 40, right: 20, bottom: 20, top: 10 },
    tooltip: { trigger: 'axis' },
  };

  const lineOption = {
    color: colors,
    backgroundColor: background,
    tooltip: {
      trigger: 'axis',
    },
    legend: {
      data: ['Email', 'Union Ads', 'Video Ads', 'Direct'],
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: ['1', '2', '3', '4'],
    },
    yAxis: {
      type: 'value',
    },
    series: [
      {
        name: 'Email',
        type: 'line',
        data: [120, 302, 101, 534],
      },
      {
        name: 'Union Ads',
        type: 'line',
        data: [320, 382, 491, 234],
      },
      {
        name: 'Video Ads',
        type: 'line',
        data: [550, 632, 601, 654],
      },
      {
        name: 'Direct',
        type: 'line',
        data: [990, 732, 901, 1034],
      },
    ],
  };

  const pieOption = {
    color: colors,
    backgroundColor: background,
    tooltip: {
      trigger: 'item',
    },
    legend: {
      orient: 'horizontal',
      top: 'top',
      left: 'center',
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: '50%',
        data: [
          { value: 1048, name: 'Partner' },
          { value: 735, name: 'Direct' },
          { value: 580, name: 'Email' },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
  };

  const renderCrossTab = () => {
    const headers = ["Region", "Q1", "Q2", "Q3", "Q4"];
    const data = [
      ["North", 120, 130, 145, 160],
      ["South", 150, 165, 170, 180],
      ["East", 100, 115, 125, 135],
      ["West", 200, 190, 185, 195],
    ];

    return (
      <div>
        <h4
          style={{
            marginBottom: 8,
            fontSize: 16,
            color: "#333",
            transform: "TranslateX(-20px)",
          }}
        >
          CrossTab
        </h4>
        <table
          style={{
            borderCollapse: "collapse",
            width: 350,
            height: 200,
            fontSize: 12,
            transform: "translateX(-30px)",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: tableHeaderBackground }}>
              {headers.map((head, idx) => (
                <th
                  key={idx}
                  style={{
                    border: "1px solid #ccc",
                    padding: "6px 8px",
                    textAlign: "left",
                  }}
                >
                  {head}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, colIndex) => (
                  <td
                    key={colIndex}
                    style={{
                      border: "1px solid #ddd",
                      padding: "6px 8px",
                      backgroundColor:
                        colIndex === 0
                          ? tableHeaderBackground // First column (Region)
                          : background, // Data cells
                    }}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };


  return (
    <div style={{transform: "TranslateY(-30px)"}}>
      <h3
        style={{
          fontSize: 18,
          fontWeight: 600,
          color: "#333",
          marginBottom: 12,
          transform: "translateX(-40px)",
        }}
      >
        Preview
      </h3>
      <div style={{ display: "flex", gap: "20px" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div>
            <h4 style={{ marginBottom: 8, fontSize: 16, color: "#333", transform: "TranslateX(-20px)" }}>
              Bar Chart
            </h4>
            <ReactECharts option={barOption} style={{ height: 200, width: 350, transform: "translateX(-30px)" }} />
          </div>
          <div>
            <h4 style={{ marginBottom: 8, fontSize: 16, color: "#333", transform: "TranslateX(-20px)" }}>
              Pie Chart
            </h4>
            <ReactECharts option={pieOption} style={{ height: 200, width: 350, transform: "translateX(-30px)" }} />
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div>
            <h4 style={{ marginBottom: 8, fontSize: 16, color: "#333", transform: "TranslateX(-20px)" }}>
              Line Chart
            </h4>
            <ReactECharts option={lineOption} style={{ height: 200, width: 350, transform: "translateX(-25px)" }} />
          </div>
          <div>{renderCrossTab()}</div>
        </div>
      </div>
    </div>
  );
};

export default ChartPreview;
